import * as queries from '@sendpayments/graphql/queries';
import { CoconutTypes } from '@sendpayments/shared-constants/types';
import { query } from '@send-base/utilities/endpoint';
import { buildUniqueKey } from '@sendpayments/js-utils/dist/services/build-unique-key';
import { useRemoteData } from '@sendpayments/react-shared/hooks/useRemoteData';

const fetchConversions = async ({ email }) => {
  let nextToken = null;
  const items = [];
  do {
    const response = await query(queries.listCoconutsByOwner, {
      params: { owner: email, type: { eq: CoconutTypes.CONVERSION }, sortDirection: 'DESC', nextToken },
    });
    if (response.items) {
      items.push(...response.items);
    }
    nextToken = response?.nextToken ?? null;
  } while (nextToken);
  return items;
};

const useConversionsByOwner = ({ owner }) =>
  useRemoteData(
    () => ({
      key: buildUniqueKey('queries.listCoconutsByOwner', { type: CoconutTypes.CONVERSION }),
      onInitialFetch: () => fetchConversions({ email: owner }),
      initialState: [],
    }),
    [owner],
  );

export default useConversionsByOwner;
